import { X } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { MicRecorder } from "@/components/add/MicRecorder";
import { PhotoCapture } from "@/components/add/PhotoCapture";
import { ManualForm } from "@/components/add/ManualForm";
import { ChequeCapture } from "@/components/add/ChequeCapture";
import { QrCapture } from "@/components/add/QrCapture";

const TITLES = {
  voice: { ar: "تسجيل صوتي", en: "Voice entry" },
  photo: { ar: "صورة الفاتورة", en: "Photo receipt" },
  manual: { ar: "إدخال يدوي", en: "Manual entry" },
  cheque: { ar: "تصوير شيك", en: "Scan cheque" },
  qr: { ar: "مسح QR / باركود", en: "Scan QR / Barcode" },
};

export function AddSheet({ mode, opts = {}, onClose }) {
  const { lang } = useI18n();
  if (!mode) return null;
  const title = TITLES[mode]?.[lang] || TITLES[mode]?.en || "";
  return (
    <div
      data-testid="add-sheet-overlay"
      className="fixed inset-0 z-40 bg-black/40 backdrop-blur-md flex items-end sm:items-center justify-center p-2 sm:p-4"
      onClick={onClose}
    >
      <div
        data-testid={`add-sheet-${mode}`}
        onClick={(e) => e.stopPropagation()}
        className="neu-scope w-full max-w-2xl neu rounded-t-3xl sm:rounded-3xl max-h-[92vh] flex flex-col"
      >
        <div className="flex items-center justify-between p-5 shrink-0">
          <p className="font-display font-bold text-lg">{title}</p>
          <button data-testid="add-sheet-close" onClick={onClose} className="p-2 rounded-xl neu-sm">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto overflow-x-hidden p-6 pt-2">
          {mode === "voice" && <MicRecorder autoStart onDone={onClose} />}
          {mode === "photo" && <PhotoCapture onDone={onClose} />}
          {mode === "manual" && <ManualForm prefill={opts.prefill} onDone={onClose} />}
          {mode === "cheque" && <ChequeCapture direction={opts.direction || "outgoing"} onDone={onClose} />}
          {mode === "qr" && <QrCapture onDone={onClose} />}
        </div>
      </div>
    </div>
  );
}
